export default __webpack_public_path__ + "static/packing1-a9c4117953e2291677f48173eaf74447.jpg";